<script setup>
import { ChevronRightIcon } from "@lucide/vue";

import { cn } from "../../../lib/utils";

const props = defineProps({
  class: { type: null, required: false },
});
</script>

<template>
  <li
    data-slot="breadcrumb-separator"
    role="presentation"
    aria-hidden="true"
    :class="cn('[&>svg]:size-3.5', props.class)"
  >
    <slot>
      <ChevronRightIcon class="cn-rtl-flip" />
    </slot>
  </li>
</template>
